import { Instagram, Mail, Phone, Youtube } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0B1A] text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and Description */}
          <div className="space-y-4">
            <img
              src="/logo-white.png"
              alt="Kampüs Logo"
              className="h-18 w-auto"
            />
            <p className="text-gray-400 mt-4">
              Sınav sürecinde öğrencilere destek olarak, yalnızca hedeflerine değil, en güçlü versiyonlarına ulaşmalarına yardımcı oluyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-brand-primary">Kısayollar</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigate('/')}
                  className="text-gray-400 hover:text-brand-primary transition-colors"
                >
                  Ana Sayfa
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/coaches')}
                  className="text-gray-400 hover:text-brand-primary transition-colors"
                >
                  Mentörlerimiz
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/contact')}
                  className="text-gray-400 hover:text-brand-primary transition-colors"
                >
                  İletişim
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-brand-primary">İletişime Geçin</h3>
            <div className="space-y-3">
              <p className="text-gray-400">
                Sosyal medya platformlarından bize ulaşabilirsiniz!
              </p>
              {/* Social Media Links */}
              <div className="flex items-center gap-4 mt-4">
                <a
                  href="https://www.instagram.com/oguzhanyildirim.yks/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:text-gray-400 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="https://youtube.com/@kampusmentorluk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:text-gray-400 transition-colors"
                >
                  <Youtube className="w-5 h-5" />
                </a>
                <a
                  href="https://www.tiktok.com/@oguzhanyildirim.yks"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:text-gray-400 transition-colors"
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                  </svg>
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-brand-primary" />
                <a
                  href="mailto:info@kampusmentorluk.com"
                  className="text-gray-400 hover:text-brand-primary transition-colors"
                >
                  info@kampusmentorluk.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-brand-primary" />
                <a
                  href="tel:+905415921450"
                  className="text-gray-400 hover:text-brand-primary transition-colors"
                >
                  +90 541 592 1450
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright and Legal Links */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex justify-between items-center">
          <p className="text-gray-400 text-sm">© {currentYear} Kampüs Mentörlük. Tüm hakları saklıdır.</p>
          <div className="flex gap-4">
            <button
              onClick={() => navigate('/aydinlatma-metni')}
              className="text-sm text-gray-400 hover:text-brand-primary transition-colors"
            >
              Aydınlatma Metni
            </button>
            <button
              onClick={() => navigate('/gizlilik-sozlesmesi')}
              className="text-sm text-gray-400 hover:text-brand-primary transition-colors"
            >
              Gizlilik Sözleşmesi
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}; 